/** A random RFC 9562 version 4 UUID for browser-side code.
 *
 *  An instance installed on a bare LAN address is served over plain HTTP, which is not a secure context:
 *  there the browser leaves `crypto.randomUUID` undefined, while `crypto.getRandomValues` is available
 *  everywhere. Every browser-side identifier, in the web app and in plugin web bundles, comes from here. */
export function randomId() {
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
